import { useEffect, useState } from "react";

import { useApi } from "@backstage/core-plugin-api";
import { githubApiRef } from "@internal/backstage-plugin-github-react";
import { getDataOrThrow } from "@internal/backstage-plugin-utility-common";

/**
 * Fetches the list of Spanner domain paths from GitHub.
 *
 * @returns An object containing the `domains` list and a `loading` flag.
 */
export function useSpannerDomains(): { domains: string[]; loading: boolean } {
    const client = useApi(githubApiRef);
    const [domains, setDomains] = useState<string[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const run = async () => {
            try {
                const tree = getDataOrThrow(
                    await client.repo.getTree("banno", "banno-infra", "main", {
                        recursive: true,
                    })
                );
                const paths = Array.from(
                    new Set(
                        tree
                            .filter(
                                item =>
                                    item.type === "blob" &&
                                    item.path?.endsWith("/spanner/main.tf")
                            )
                            .map(
                                item =>
                                    item
                                        .path!.replace(/^iac\/[^/]+\//, "")
                                        .split("/")[0]
                            )
                    )
                );
                setDomains(paths);
            } catch (err) {
                console.error(
                    "useSpannerDomains: failed to fetch Spanner domains from GitHub",
                    err
                );
            } finally {
                setLoading(false);
            }
        };
        run();
    }, [client]);

    return { domains, loading };
}
